















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { IcoachSkill, IcoachSkillComment as PublishedComment } from '@/interfaces/IcoachInterfaces'
import { IcoachData } from '@/interfaces/LocalStorageInterfaces'
import IcoachService from '@/services/IcoachService'

@Component({ name: 'IcoachSkillComment' })
export default class IcoachSkillComment extends Vue {
  @Prop({ required: true })
  icoachSkill!: IcoachSkill
  @Prop({ required: true })
  icoachUserData!: IcoachData
  @Prop({ required: true })
  stepId!: number

  comment: string = ''
  publishedComments: PublishedComment[] = []
  visible: Boolean = true

  @Watch('stepId')
  onStepIdChange () {
    this.uploadComments()
    this.resetComments()
  }

  async created () {
    await this.uploadComments()
  }

  async submit () {
    if (!await this.$validator.validateAll()) {
      return
    }

    if (!this.icoachUserData.icoachAccessCode) {
      return
    }

    try {
      const skillComment = await IcoachService.createIcoachSkillComment(
        this.icoachUserData.icoachCourseId,
        this.icoachSkill.id,
        Number(this.stepId),
        this.comment
      )

      this.comment = ''
      await this.$validator.reset()
      this.publishedComments.unshift(skillComment)

      this.$store.commit('icoach/updateIcoachProgress', {
        currentSkill: this.icoachSkill.id,
        currentStep: this.stepId
      })
    } catch (error) {
      throw error
    }
  }

  async uploadComments () {
    this.publishedComments = await IcoachService.getIcoachSkillComments(
      this.icoachSkill.id,
      this.stepId,
      this.icoachUserData.icoachUserId
    )
  }

  private resetComments () {
    this.$validator.reset()
    this.publishedComments = []
  }
}
